/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m24.13 2h4.87c.552 0 1 .448 1 1v26c0 .553-.448 1-1 1h-4.87-16.26-4.87c-.552 0-1-.447-1-1v-22.347c0-.266.105-.52.293-.707l3.652-3.653c.188-.187.442-.293.707-.293h1.218zm3.87 26v-24h-2.87v5.087c0 .553-.447 1-1 1h-16.26c-.553 0-1-.447-1-1v-4.889l-2.87 2.869v20.933h2.87v-2.652c0-.553.447-1 1-1h16.26c.553 0 1 .447 1 1v2.652zm-19.13 0h14.261v-1.652h-14.261zm-.001-19.913h14.261v-4.087h-14.261zm1.9884805 8.304938c0-2.8349562 2.3075632-5.1425195 5.1425195-5.1425195s5.1425195 2.3075633 5.1425195 5.1425195c0 2.8349563-2.3075632 5.1416435-5.1425195 5.1416435s-5.1425195-2.3066872-5.1425195-5.1416435zm1.7521361 0c0 1.8695293 1.5208542 3.3895074 3.3903834 3.3895074s3.3903834-1.5199781 3.3903834-3.3895074c0-1.8695292-1.5208542-3.3903834-3.3903834-3.3903834s-3.3903834 1.5208542-3.3903834 3.3903834z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;